import { render, staticRenderFns } from "./JobInProcess.vue?vue&type=template&id=39b9d71c&scoped=true"
import script from "./JobInProcess.vue?vue&type=script&lang=js"
export * from "./JobInProcess.vue?vue&type=script&lang=js"
import style0 from "./JobInProcess.vue?vue&type=style&index=0&id=39b9d71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9d71c",
  null
  
)

export default component.exports